import type { IObjectiveTermOfCreditSought } from './ObjectiveTermOfCreditSought.interface';

export default class ObjectiveTermOfCreditSought implements IObjectiveTermOfCreditSought {
  years: number;
  months: number;
  preferredLenders: string;
  notLenders: string;

  static build = (data: IObjectiveTermOfCreditSought) => new ObjectiveTermOfCreditSought(data);
  static blank = () => new ObjectiveTermOfCreditSought();

  /**
   * Constructor
   * @param {IObjectiveTermOfCreditSought} data
   */
  constructor(data?: IObjectiveTermOfCreditSought) {
    this.years = parseInt(data?.years || 0, 10);
    this.months = parseInt(data?.months || 0, 10);
    this.preferredLenders = data?.preferredLenders || '';
    this.notLenders = data?.notLenders || '';
  }
}
